import { getToken } from '@api/api';
import Axios from 'axios';

Axios.defaults.baseURL = window.location.origin + '/api';
Axios.defaults.withCredentials = false;

export const fetcher = async (url: string) => {
  const token = await getToken();
  const res = await Axios.get(url, {
    headers: { Authorization: `Bearer ${token}` }
  });

  return res.data;
};

export const modifier = async (url: string, payload: object) => {
  const token = await getToken();
  const headers: { [key: string]: string } = {
    Authorization: `Bearer ${token}`
  };

  try {
    const { data } = await Axios.post(url, payload, { headers });
    return { data, error: undefined };
  } catch (error) {
    return { error, data: undefined };
  }
};
